export type Webhook = {
  bearerToken: string;
  id: string | symbol;
  name: string;
  url: string;
  topic: string;
  kind: string;
  status?: WebhookStatus;
};

export enum WebhookStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export type Client = {
  id: string | symbol;
  name: string;
  bearerToken: string;
  teams: string[];
};

export type DeveloperValue = { webhooks: Webhook[]; apiClients: Client[] };

export type WebhookValue = {
  bearerToken: string;
  name: string;
  url: string;
  topic: string;
  kind: string;
};

export type ClientValue = {
  name: string;
  bearerToken: string;
  teams: string[];
};
